import { Link } from "@mui/material";
import {
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid-pro";
import { format } from "date-fns";
import { Status } from "entities/users/types";
import Chip from "shared/components/Chip";
import { getChipColor } from "../../utils";

export const chipTitleMap: Record<Status, string> = {
  [Status.REGISTERED]: "Registered",
  [Status.BOT_INTERACTION_ONLY]: "Bot Interaction Only",
  [Status.DEPOSITED]: "Deposited",
};

const prefixToRemove = "telegram_";

const renderStatusCell = (params: GridRenderCellParams) => {
  const color = getChipColor(params.value);
  const title = chipTitleMap[params.value as Status] || "Bot Interaction Only";

  return <Chip title={title} bgColor={color} />;
};

export const getUserColumns = () => {
  return [
    {
      field: "id",
      headerName: "Telegram ID",
      editable: false,
      sortable: true,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) =>
        params.value.replace(prefixToRemove, ""),
    },
    {
      field: "iCoreUserIds",
      headerName: "iCore ID",
      editable: false,
      sortable: true,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) => {
        if (params.value && params.value.length > 0) {
          return (
            <Link
              href={`${process.env.REACT_APP_ICORE_LINK}/Summary/${params.value[0]}`}
              target="_blank"
              rel="noreferrer"
            >
              {params.value[0]}
            </Link>
          );
        }
        return "N/A";
      },
    },
    {
      field: "firstName",
      headerName: "First Name",
      editable: false,
      sortable: true,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) =>
        params.value ? params.value : "N/A",
    },
    {
      field: "username",
      headerName: "Username",
      editable: false,
      sortable: true,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) =>
        params.value ? params.value : "N/A",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      editable: false,
      sortable: true,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) => {
        if (params.value) {
          return format(params.value, "dd MMM yyyy, HH:mm");
        }
      },
    },
    {
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: renderStatusCell,
    },
  ];
};
